import { useEffect, useMemo, useState } from "react";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { useSpinner } from "../../../customHooks";
import { listAlertusTokens, selector as AlertusTokensSelector } from "./listAlertusTokenSlice";
import { DataAvailabilityMessages, Status, WEBHOOK_PLACEHOLDER } from "../../../common/constants";
import { alertusWebhookURL } from "../../../config";

const useAlertus = () => {
  const [rows, setRows] = useState<any[]>([]);
  const dispatch: ThunkDispatch<any, undefined, Action> = useDispatch();
  const [globalFilter, setGlobalFilter] = useState<string>("");
  const [text, setText] = useState<string>(WEBHOOK_PLACEHOLDER.PLACEHOLDER);
  const [copied, setCopied] = useState<boolean>(false);
  const apiState = useSelector(AlertusTokensSelector);
  const tokens: any[] = apiState?.tokens?.message ?? [];
  const apiStatus: string = apiState?.status ?? Status.IDLE;
  
  useSpinner(apiState.status);
  useEffect(() => {
    if (apiStatus === Status.IDLE) {
      dispatch(listAlertusTokens());
    }
  }, [apiStatus, dispatch]);

  const formattedRows = useMemo(() =>
    tokens
      .map((t) => ({
        id: t.entryId,
        name: t.tokenName,
        createAt: new Date(t.issuedAt * 1000).toLocaleString(),
        endAt: (() => {
          if (t.expiresAt === "never" || t.expiresAt === null || t.expiresAt === undefined) {
            return "Never";
          }
          if (typeof t.expiresAt === 'number' && !isNaN(t.expiresAt)) {
            return new Date(t.expiresAt * 1000).toLocaleString();
          }
          if (typeof t.expiresAt === 'string' && !isNaN(Number(t.expiresAt))) {
            return new Date(Number(t.expiresAt) * 1000).toLocaleString();
          }
          return "Never";
        })(),
      }))
  , [tokens]);
  

  const filteredRows = useMemo(() => {
    if (!globalFilter.trim()) return formattedRows;
    return formattedRows.filter((row) =>
      row.name.toLowerCase().includes(globalFilter.trim().toLowerCase())
    );
  }, [globalFilter, formattedRows]);

  useEffect(() => {
    setRows(filteredRows);
  }, [filteredRows, globalFilter]);

  useEffect(()=>{
    setText(`${alertusWebhookURL}`);
    
  },[])

  const noDataMessage =
    apiStatus === Status.PENDING
      ? DataAvailabilityMessages.TOKEN_DATA_LOADING
      : DataAvailabilityMessages.NO_TOKEN_AVAILABLE;

  return {
    rows,
    globalFilter,
    setGlobalFilter,
    noDataMessage,
    text,
    setText,
    copied,
    setCopied,
  };

};

export default useAlertus;
